module.exports = __webpack_public_path__ + "static/media/ayushman.e6b1a1dd.webp";